module.exports = __webpack_public_path__ + "media/beach_red.273ba89a.mp4";